import styled from "styled-components";
import { SIDEBAR_PROPS } from "../../layouts/sidebars-layout/sidebar-layout.constants";


export const NpsContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;

  display: flex;
  justify-content: center;
  align-items: center;
  z-index: ${SIDEBAR_PROPS.SIDE_BAR_Z_INDEX + 10};

  background-color: ${({ theme }) => theme.colors.primaryPurple.main}aa;
  backdrop-filter: blur(5px);
`;

export const NpsContent = styled.div`
  position: relative;
  width: 100%;
  max-width: 500px;
  padding: 1rem 2rem;
  background-color: ${({ theme }) => theme.colors.white.main};
  border-radius: 10px;
  box-shadow: 0 0 10px 0 ${({ theme }) => theme.colors.gray900.main}44;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const NpsButton = styled.button`
    width: fit-content;
    padding: 0.5rem 1rem;
    margin-top: 1rem;
    border: none;
    border-radius: 5px;
    background-color: ${({ theme }) => theme.colors.primaryBlue.main};
    color: ${({ theme }) => theme.colors.white.main};
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.3s;
    align-self: flex-end;
    
    &:hover {
        background-color: ${({ theme }) => theme.colors.primaryBlue.hover};
    }

    &:disabled {
        background-color: ${({ theme }) => theme.colors.gray400.main};
        cursor: not-allowed;
    }
`;


